// src/grecaptcha/store.ts
import { useSyncExternalStore } from "react";
var context = { provider: "google" };
var presolved = null;
var listeners = /* @__PURE__ */ new Set();
var notify = () => listeners.forEach((listener) => listener());
var setCaptchaContext = ({ provider = "google", locale }) => {
  if (context.provider === provider && context.locale === locale) return;
  context = { provider, locale };
  notify();
};
var getCaptchaProvider = () => context.provider;
var getCaptchaLocale = () => context.locale;
var setPresolvedGeeTest = (result) => {
  if (presolved === result) return;
  presolved = result;
  notify();
};
var takePresolvedGeeTest = () => {
  const result = presolved;
  setPresolvedGeeTest(null);
  return result;
};
var hasPresolvedGeeTest = () => presolved !== null;
var subscribe = (listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
var useCaptchaProvider = () => useSyncExternalStore(subscribe, getCaptchaProvider, getCaptchaProvider);
var useCaptchaLocale = () => useSyncExternalStore(subscribe, getCaptchaLocale, getCaptchaLocale);
var usePresolvedGeeTest = () => useSyncExternalStore(subscribe, hasPresolvedGeeTest, hasPresolvedGeeTest);

export {
  setCaptchaContext,
  getCaptchaProvider,
  getCaptchaLocale,
  setPresolvedGeeTest,
  takePresolvedGeeTest,
  hasPresolvedGeeTest,
  useCaptchaProvider,
  useCaptchaLocale,
  usePresolvedGeeTest
};
//# sourceMappingURL=chunk-P2B2TNGX.mjs.map